import React, {Component, Fragment} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';
import AddField from "./AddField";
import Options from "./Options";
import CheckAll from "./CheckAll";
import {StoreContext} from "../../stores/contexts";

class Header extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      dragging_column:false,
      drag_enter_pos:''
    }
  }
  renderOrderMark(field) {
    const mark=this.context.memoryStore.getOrder(field.code);
    if(mark) {
      if(mark === 'asc') {
        return <i className={`mdi mdi-chevron-up`}></i>
      } else {
        return <i className={`mdi mdi-chevron-down`}></i>
      }
    } {
      return null;
    }
  }
  isColumUseInSort(field)
  {
    if(field) {
      return this.context.memoryStore.getOrder(field.code);
    }
    return false;
  }
  dropHit(pos,ind,data) {
    this.context.configStore.moveColumn(parseInt(data.dragData.column_index),parseInt(ind),pos);
    console.log(pos,ind,data.dragData);
  }
  renderFields() {
    const iReturn=[];
    for(let i in this.context.configStore.layout) {
      const field=this.context.configStore.layout[i];
      const style={};
      let columnInSort=false;

      if(this.isColumUseInSort(field)) {
        columnInSort=true;
        style.background='#c6d7e4';
      }

      iReturn.push(
        <td className={`pointer pr ${this.state.dragging_column === i?"transp100":""} ${columnInSort?"sortActivate":""}`} style={style} key={i} onClick={()=>{ this.context.memoryStore.setOrder(field.code); }}>
          <div style={{minWidth:50}}>
            <div className="up12 splice s-nowrap">
              <div className="cell s-shrink" style={{flexShrink:1}}>
                {field.name}
              </div>
              <div className="cell s-shrink s-middle">
                {this.renderOrderMark(field)}
              </div>
            </div>
          </div>
          {this.context.configStore.layout_editor?(
            
              <div className="pa pa-tl w100 h100">
                <DragDropContainer
                  dragData={{column_index:i}}
                  returnToBase={true}
                  dragClone={true}
                  targetKey="header"
                  onDragStart={()=>{
                    this.setState({ dragging_column:i });
                    console.log("drag_start");
                    this.context.dragStore.dragging=true;
                    this.context.dragStore.drag_type="section";
                    this.context.dragStore.drag_source=this.props.item;
                  }}
                  onDragEnd={()=>{
                    this.setState({ dragging_column:false });
                    this.context.dragStore.dragging=false;
                    this.context.dragStore.drag_type="";
                    this.context.dragStore.drag_source={};
                    console.log("DRAG END!!!");
                  }}
                  onDrop={(data)=>{
                    console.log("DROP!!!",data);
                  }}
                  elementProps={{ style:{ display:'block', position:'static', width:'100%', height:'100%'}}}
                >
                  <div className="up12 splice h100 w100 bg-w3 b4" onContextMenu={(e)=>{ this.context.contextStore.show(e,'header',field); }}>
                    <div className="cell s-middle s-12">
                      <div className="hpadd10 vpadd10 lh15 fs13 bold">
                        {field.name}
                      </div>
                    </div>
                  </div>
              </DragDropContainer>
            </div>
          ):null}
          {this.context.dragStore.dragging?(
            <>
              <DropTarget
                targetKey="header"
                onDragEnter={()=>{ this.setState({ drag_enter_pos:'left', drag_enter_index:i }); }}
                onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                onHit={(data)=>{ this.dropHit('before',i,data); }}
              >
                <div className="pa pa-tl h100 z3 " style={{width:'50%'}}>
                  {this.state.drag_enter_pos === 'left' && this.state.drag_enter_index === i ?(
                    <div className="pa pa-tl h100 bg-b1-op50" style={{width:4, left:-2}}></div>
                  ):null}
                </div>
              </DropTarget>
              <DropTarget
                targetKey="header"
                onDragEnter={()=>{ this.setState({ drag_enter_pos:'right', drag_enter_index:i }); }}
                onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                onHit={(data)=>{ this.dropHit('after',i,data); }}
              >
                <div className="pa pa-tr h100 z3" style={{width:'50%'}}>
                  {this.state.drag_enter_pos === 'right' && this.state.drag_enter_index === i?(
                    <div className="pa pa-tr h100 bg-b1-op50" style={{width:4, right:-2}}></div>
                  ):null}
                </div>
              </DropTarget>
            </>
          ):null}
        </td>
      )
    }
    return iReturn;
  }
  render() {
    return (
      <thead>
        <tr>
          {this.context.configStore.config.data.enable_select || this.context.configStore.config.data.enable_drag?(
            <td className=" pr wsnw">
              {this.context.configStore.config.data.enable_drag?(
                <i className="mdi mdi-dots-vertical fs24 transp100 pr dib" style={{ left: -12, top: 1, width:10 }}></i>
              ):null}
              {this.context.configStore.config.data.enable_select?(
                <CheckAll />
              ):null}
            </td>
          ):null}
          {this.renderFields()}
          {this.context.configStore.layout_editor?(
            <td className="pr" style={{textAlign:'right'}}>
              <AddField />
              <Options />
            </td>
          ):(
            <td className=" pr" style={{textAlign:'right'}}>
              <i className={`mdi mdi-refresh fs24 pointer ${this.context.dataStore.data.fetching?'mdi-spin':''}`} onClick={()=>{ this.context.dataStore.refreshData(); }}></i>
              <Options />
            </td>
          )}
        </tr>
      </thead>
    )
  }
}

// export default inject("configStore","memoryStore","dataStore","dragStore","contextStore")(observer(Header));
export default observer(Header);